import React, { useEffect, useState, useMemo } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import "./Products.css";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function Products() {

  const [allProducts, setAllProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState({});
  const [searchTermLocal, setSearchTermLocal] = useState("");
  const [user, setUser] = useState(null);

  const navigate = useNavigate();
  const query = useQuery();

  const activeCategory = query.get("category") || "";
  const urlSearch = query.get("search") || "";

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  const requireLogin = (redirectUrl) => {
    if (!user) {
      navigate(`/login?redirect=${encodeURIComponent(redirectUrl)}`);
      return false;
    }
    return true;
  };

  useEffect(() => {
    const fetchProducts = async () => {
      const snap = await getDocs(collection(db, "products"));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setAllProducts(list);
    };

    fetchProducts();
  }, []);

  useEffect(() => {

    let list = [...allProducts];

    if (activeCategory) {
      list = list.filter(
        (p) =>
          (p.category || "").toLowerCase() === activeCategory.toLowerCase()
      );
    }

    const q = (urlSearch || "").toLowerCase();

    if (q) {
      list = list.filter(
        (p) =>
          (p.name || "").toLowerCase().includes(q) ||
          (p.description || "").toLowerCase().includes(q)
      );
    }

    setProducts(list);

  }, [allProducts, activeCategory, urlSearch]);

  useEffect(() => {
    setSearchTermLocal(urlSearch || "");
  }, [urlSearch]);

  const handleSizeSelect = (productId, size) => {
    setSelectedSizes((prev) => ({
      ...prev,
      [productId]: size,
    }));
  };

  const handleAddToCart = (p) => {

    const size = selectedSizes[p.id];

    if (p.sizes?.length && !size) {
      alert("Please select size");
      return;
    }

    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    cart.push({
      id: p.id,
      name: p.name,
      price: p.price,
      image: p.image,
      size,
      qty: 1,
    });

    localStorage.setItem("cart", JSON.stringify(cart));

    alert("Added to cart");

  };

  const handleBuyNow = (p) => {

    const size = selectedSizes[p.id];

    if (p.sizes?.length && !size) {
      alert("Please select size");
      return;
    }

    sessionStorage.setItem(
      "kwicth_buy_now",
      JSON.stringify({
        id: p.id,
        name: p.name,
        price: p.price,
        image: p.image,
        size: size || null,
        qty: 1,
      })
    );

    navigate("/checkout");

  };

  const onSearchSubmit = (e) => {

    e.preventDefault();

    if (searchTermLocal) {
      navigate(`/products?search=${encodeURIComponent(searchTermLocal)}`);
    } else {
      navigate("/products");
    }

  };

  return (

    <main className="products-page">

      <header className="prod-header">

        <h1>Products</h1>

        <form onSubmit={onSearchSubmit}>

          <input
            value={searchTermLocal}
            onChange={(e) => setSearchTermLocal(e.target.value)}
            placeholder="Search products..."
          />

        </form>

      </header>

      <section className="prod-grid">

        {products.length === 0 ? (

          <div>No products found</div>

        ) : (

          products.map((p) => (

            <article className="prod-card" key={p.id}>

              <div
                onClick={() => {
                  if (!requireLogin(`/product/${p.id}`)) return;
                  navigate(`/product/${p.id}`);
                }}
              >
                <img src={p.image} alt={p.name} />
              </div>

              <h3>{p.name}</h3>

              <div className="prod-sizes">

                {p.sizes?.map((s) => (

                  <button
                    key={s}
                    className={selectedSizes[p.id] === s ? "selected" : ""}
                    onClick={() => handleSizeSelect(p.id, s)}
                  >
                    {s}
                  </button>

                ))}

              </div>

              <div className="prod-price">
                ₹{p.price}
              </div>

              <div className="prod-actions">

                <button onClick={() => handleAddToCart(p)}>
                  Add
                </button>

                <button onClick={() => handleBuyNow(p)}>
                  Buy
                </button>

              </div>

            </article>

          ))

        )}

      </section>

    </main>

  );
}